import request from '@/services/interceptor.js'

export const get_scadenzeMezzo = (filtri) => {
    return request({
        url: '/scadenzamezzo',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_scadenzaMezzo = (id) => {
    return request({
        url: `/scadenzamezzo/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_scadenzaMezzo = (par) => {
    return request({
        url: '/scadenzamezzo',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_scadenzaMezzo = (id, par) => {
    return request({
        url: `/scadenzamezzo/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

// A differenza di /api/manutenzione, non esiste l'azione "inizia": una
// scadenza mezzo non ha wizard di fermo (niente RichiedeFermoMacchina/DataInizio).
export const completa_scadenzaMezzo = (id, par) => {
    return request({
        url: `/scadenzamezzo/${id}/completa`,
        method: 'post',
        data: par,
        loadingBar: true
    })
}

// Annulla un completamento registrato per errore: la scadenza torna pianificata.
export const riapri_scadenzaMezzo = (id) => {
    return request({
        url: `/scadenzamezzo/${id}/riapri`,
        method: 'post',
        loadingBar: true
    })
}

// Correzione a posteriori di una scadenza già completata (note, data di esecuzione).
export const modifica_completamento_scadenzaMezzo = (id, par) => {
    return request({
        url: `/scadenzamezzo/${id}/completamento`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_scadenzaMezzo = (id) => {
    return request({
        url: `/scadenzamezzo/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const elimina_scadenzaMezzo = (id) => {
    return request({
        url: `/scadenzamezzo/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
